import { render, staticRenderFns } from "./member-setup.vue?vue&type=template&id=53da92a9&"
import script from "./member-setup.vue?vue&type=script&lang=ts&"
export * from "./member-setup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports